/**
 * Colour ramps shared by the theme presets in `./presets.ts`.
 *
 * The surface ramps are warm neutrals rather than Aura's stock `slate`/`zinc`.
 * Slate carries a blue undertone that sits badly next to the burnt-orange
 * primary; a warm grey shares the primary's undertone so the two agree.
 */

/** Exosource burnt orange. */
export const primaryPalette = {
  '50': '#fdf6ef',
  '100': '#fae9da',
  '200': '#f5d0b3',
  '300': '#eeb083',
  '400': '#e68751',
  '500': '#e16e38',
  '600': '#d15025',
  '700': '#ae3c20',
  '800': '#8b3221',
  '900': '#702c1e',
  '950': '#3c140e',
};

/** Warm neutral ramp for light mode: 0 is lightest, 950 is darkest. */
export const lightSurfacePalette = {
  '0': '#ffffff',
  '50': '#faf9f7',
  '100': '#f4f2ee',
  '200': '#e9e5df',
  '300': '#d8d2ca',
  '400': '#b0a89f',
  '500': '#7a726b',
  '600': '#655e57',
  '700': '#4b4540',
  '800': '#332f2c',
  '900': '#1f1c1a',
  '950': '#121010',
};

/**
 * Warm neutral ramp for dark mode, **inverted**: 0 is darkest, 950 is lightest.
 *
 * Aura's own dark scheme keeps the ramp pointing the same way as light mode, so
 * `surface.0` stays `#ffffff` and a template that writes `bg-surface-0` stays
 * white in the dark. This app styles its shell with those Tailwind classes
 * (`bg-surface-0`, `bg-surface-50`, `text-surface-900`, `border-surface-200`),
 * so inverting the ramp lets every one of them flip on its own with no
 * `dark:` variants in the templates. The cost is that the dark `colorScheme`
 * has to restate Aura's semantic tokens against the flipped ramp — that is what
 * `darkColorScheme` in `./presets.ts` does.
 */
export const darkSurfacePalette = {
  '0': '#141210',
  '50': '#1c1917',
  '100': '#262220',
  '200': '#332e2b',
  '300': '#443e3a',
  '400': '#5c554f',
  '500': '#7a726b',
  '600': '#9d948c',
  '700': '#c4bbb3',
  '800': '#ded7d0',
  '900': '#efeae5',
  '950': '#faf8f6',
};
